import { render, staticRenderFns } from "./ChangeOrdersList.vue?vue&type=template&id=1cca5916"
import script from "./ChangeOrdersList.vue?vue&type=script&lang=js"
export * from "./ChangeOrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports